module.exports = __webpack_public_path__ + "static/media/sort-shapes-down.e3ff1e21.svg";